import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { orderService } from "./orderService";
import { toast } from "react-toastify";

// Create Order
export const createOrder = createAsyncThunk("user/order", async (orderData, thunkAPI) => {
    try {
        return await orderService.createOrder(orderData)
    } catch (error) {
        return thunkAPI.rejectWithValue(error)
    }
})


const getOrderFromLocalStorage = localStorage.getItem("order") 
    ? JSON.parse(localStorage.getItem("order"))
    : null

const initialState = {
    order: getOrderFromLocalStorage,
    isLoading: false,
    isSuccess: false,
    isError: false,
    message: "",
}

export const orderSlice = createSlice({
    name: "order",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Create Order
            .addCase(createOrder.pending, (state) => {
                state.isLoading = true
            })
            .addCase(createOrder.fulfilled, (state, action) => {
                state.isLoading = false
                state.isError = false
                state.isSuccess = true
                state.order = action.payload
                if (state.isSuccess === true) {
                    localStorage.setItem("order", JSON.stringify(state.order))
                    localStorage.removeItem("cartItem")
                    toast.info("Successfully")
                }
            })
            .addCase(createOrder.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.isSuccess = false
                state.message = action.error
                if (state.isError === true) {
                    toast.error(action.error)
                }
            })
    }
})

export default orderSlice.reducer

